import React, { PropsWithChildren } from 'react'
import { ThemeProvider, FormControl, FormHelperText, InputLabel, Tooltip, Typography } from '@mui/material'
import { t } from '../../../../infrastructure/i18nextHelper'
import { customSelectTheme, ClassNames } from './select'
import { FieldStatus } from '../../fieldsStatus'

export function CustomSelectWrapper(props: PropsWithChildren<CustomSelectProps & { classNames: ClassNames, disabled?: boolean, selectedTexts?: string[] }>) {
    return (
        <ThemeProvider theme={customSelectTheme}>
            <SelectedChoicesTooltip disabled={props.disabled} selectedTexts={props.selectedTexts ?? []}>
                <FormControl
                    className={props.classNames.form} error={props.status === 'alert' || !!props.onError}>
                    <InputLabel shrink className={props.classNames.input}>{props.label}</InputLabel>
                    {props.children}
                    {props.status === 'alert' || props.onError ? <FormHelperText>{t('components.error')}</FormHelperText> : null}
                </FormControl>
            </SelectedChoicesTooltip>
        </ThemeProvider>
    )
}

export function SelectedChoicesTooltip({ disabled, selectedTexts, children }: { disabled?: boolean, selectedTexts: string[], children: React.ReactElement }) {
    let text = selectedTexts.join(', ')

    if (!disabled || !text) return children

    return (
        <Tooltip title={<Typography variant='body1'>{text}</Typography>} placement='top'>
            {children}
        </Tooltip>
    )
}

export type CustomSelectProps = {
    id?: string
    label: string
    onChange?: (selectedValues: string[]) => void
    onError?: boolean
    status?: FieldStatus
}